export default __webpack_public_path__ + "static/media/icon-community.037ffe08.svg";